
import React, { useEffect, useState } from "react";
import "./AddUser.css";
import { useGlobalContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { addClient } from "../../api";
import Holidays from 'date-holidays';

function AddUser() {

    const {
        setNavbarData,
        categorys,
        profileType,
        weekDays,
        setWeekDays,
    } = useGlobalContext()

    const [activeDays, setActiveDays] = useState([]);
    const [typeProfile, setTypeProfile] = useState("");
    const [typeCategory, setTypeCategory] = useState("");
    const [additionalCategory, setAdditionalCategory] = useState("");
    const [facebookId, setFacebookId] = useState("");
    const [hashtag, setHashtag] = useState("");
    const [caption, setCaption] = useState("");
    const [checkCustomer, setCheckCustomer] = useState(false);
    const [checkClientUSA, setCheckClientUSA] = useState(true);
    const [checkClientCanada, setCheckClientCanada] = useState(false);
    const [concretDay, setConcretDay] = useState();
    const [holidaysPosts, setHolidaysPosts] = useState(true);
    const [holidays, setHolidays] = useState([]);
    const [errorSocialMedia, setErrorSocialMedia] = useState(false);

    useEffect(() => {
        if (checkCustomer) {
            setWeekDays(day => day.map((item) =>{
                return { ...item,
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                }
            }))
        }
        else {
            setWeekDays(
                [
                    {
                        id: 1,
                        text: "Mon",
                        name: "Monday",
                        active: true,
                        postToInstagram: true,
                        postToFacebook: true,
                        time: ""
                    },
                    {
                        id: 2,
                        text: "Tue",
                        name: "Tuesday",
                        active: false,
                        postToInstagram: false,
                        postToFacebook: false,
                        time: ""
                    },
                    {
                        id: 3,
                        text: "Wed",
                        name: "Wednesday",
                        active: true,
                        postToInstagram: true,
                        postToFacebook: true,
                        time: ""
                    },
                    {
                        id: 4,
                        text: "Thu",
                        name: "Thursday",
                        active: false,
                        postToInstagram: false,
                        postToFacebook: false,
                        time: ""
                    },
                    {
                        id: 5,
                        text: "Fri",
                        name: "Friday",
                        active: true,
                        postToInstagram: true,
                        postToFacebook: true,
                        time: ""
                    },
                    {
                        id: 6,
                        text: "Sat",
                        name: "Saturday",
                        active: false,
                        postToInstagram: false,
                        postToFacebook: false,
                        time: ""
                    },
                    {
                        id: 7,
                        text: "Sun",
                        name: "Sunday",
                        active: false,
                        postToInstagram: false,
                        postToFacebook: false,
                        time: ""
                    },
                ]
            )
        }
    }, [checkCustomer]);

    useEffect(()=>{
        let hdUSA = new Holidays("US");
        const holidaysUSAUpdate = hdUSA.getHolidays(new Date().getFullYear()).map((item, index) => { return { ...item, active: true, id: index + 1 } });
        let hdCanada = new Holidays("CA");
        const hdCanadaUpdate = hdCanada.getHolidays(new Date().getFullYear()).map((item, index) => { return { ...item, active: true, id: index + 1 } });
        if (checkClientUSA) {
            setHolidays(holidaysUSAUpdate);
        }
        else {
            setHolidays(hdCanadaUpdate);
        }
    },[checkClientUSA, checkClientCanada])

    const navigate = useNavigate();

    const goToAllPage = () => {
        setTypeProfile("");
        setTypeCategory("");
        setFacebookId("");
        setNavbarData(navbarData => navbarData.map(item => item.id === 1 ? { ...item, active: true } : { ...item, active: false }));
        navigate("/");
    }

    const createNewClient = async (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append("facebookProfileId", facebookId);
        formData.append("category", typeCategory.text.replaceAll(" ", "_").toUpperCase());
        additionalCategory && formData.append("additionalCategory", additionalCategory.text.replaceAll(" ", "_").toUpperCase());
        formData.append("subscription", typeProfile.text.replaceAll(" and ", "_").toUpperCase());
        formData.append("hashtags", hashtag);
        formData.append("additionalTexts", caption);
        const submitData = await addClient(formData);
        if (submitData) {
            goToAllPage();
            // const weekData = weekDays.filter(item => item.active).map(item => {
            //     return {
            //         day: item.name.toUpperCase(),
            //         postToFacebook: item.postToFacebook,
            //         postToInstagram: item.postToInstagram,
            //         postValidStartTime: item.time
            //     }
            // })
            // const activeHolidays = holidays.filter(item => item.active).map(item => item.date.slice(0, item.date.indexOf(" ")));
            // let configs = {
            //     clientId: submitData.data.id,
            //     holidayPosts: holidaysPosts,
            //     holidays: activeHolidays,
            //     dayOfWeeks: weekData,
            //     holidayCountry: checkClientUSA ? "USA" : "CANADA"
            // }
            // const configData = await createConfiguration(JSON.stringify(configs));
            // if (configData) {
            //     goToAllPage();
            // }
        }
    }

    const checkActiveDays = (item) => {
        if ( activeDays.length < 3 ) {
            const secondOrNextDay = activeDays.find(day => day.id === item.id + 1 || day.id === item.id - 1);
            if ( secondOrNextDay ) return false;
            else return true;
        }
        else if ( activeDays.length === 3 && item.active ) return true;
        else return false;
    }

    const activeThisDay = (item) => {
        if (!item.active) {
            if (activeDays.length > 0) {
                const lastActiveDay = activeDays[activeDays.length - 1];
                if (!lastActiveDay.postToFacebook && !lastActiveDay.postToInstagram) {
                    setErrorSocialMedia(true);
                }
                else {
                    setErrorSocialMedia(false);
                    setWeekDays(weekDays => weekDays.map(day => day.text === item.text ? {
                        ...day,
                        active: !day.active
                    } : { ...day }));
                    setConcretDay({...item, active: !item.active});
                }
            }
            else {
                setErrorSocialMedia(false);
                setWeekDays(weekDays => weekDays.map(day => day.text === item.text ? {
                    ...day,
                    active: !day.active
                } : {...day}));
                setConcretDay({...item, active: !item.active});
            }
        }
        else {
            setErrorSocialMedia(false);
            setWeekDays(weekDays => weekDays.map(day => day.text === item.text ? {
                ...day,
                active: !day.active
            } : { ...day }));
            const lastActiveDay = weekDays.filter(item => item.active);
            setConcretDay(lastActiveDay[lastActiveDay.length - 2]);
        }
    }

    const addDay = (item) => {
        if (checkActiveDays(item)) {
            activeThisDay(item);
        }
    }

    const changeTime = (value) => {
        setConcretDay(concretDay => {
            return { ...concretDay, time: value.$d.toLocaleTimeString("en-US") }
        });
    }

    const changeFacebook = (value) => {
        setConcretDay(concretDay => {
            return { ...concretDay, postToFacebook: value };
        })
    }

    const changeInstagram = (value) => {
        setConcretDay(concretDay => {
            return { ...concretDay, postToInstagram: value };
        })
    }

    useEffect(() => {
        if (concretDay) {
            setWeekDays(weekDays => weekDays.map(day => day.text === concretDay?.text ? { ...concretDay } : {...day}));
        }
    }, [concretDay]);

    useEffect(() => {
        const activeDays = weekDays.filter(item => item.active);
        if (activeDays.length === 0) {
            setConcretDay();
            setActiveDays([]);
        }
        else {
            setActiveDays(activeDays);
        }
    }, [weekDays])

    const checkedThisHoliday = (holiday) => {
        setHolidays(holidays => holidays.map(item => item.id === holiday.id ? { ...item, active: !item.active } : { ...item }));
    }

    useEffect(() => {
        setHolidays(holidays => holidays.map(hol => {
            return { ...hol, active: holidaysPosts };
        }))
    }, [holidaysPosts])

    return(
        <div className = "addUserFormBox">
            <form
                className="addUserForm"
                onSubmit={createNewClient}
            >
                <div className="addUserFormInputsBox">
                    <h4 className="addUserHeadText">ADD A USER</h4>
                    <label>Profile Type</label>
                    <Dropdown
                        options = {profileType}
                        optionLabel="text"
                        className="addUserDropdown"
                        value={typeProfile}
                        onChange={e => setTypeProfile(e.value)}
                        required={true}
                    />
                    <label>Facebook ID</label>
                    <input
                        type = "number"
                        className = "addUserInput"
                        value = { facebookId }
                        onChange = {e => setFacebookId(e.target.value)}
                        required = {true}
                    />
                    <label>Category</label>
                    <Dropdown
                        options = { categorys.filter(item => item.id !== 0) }
                        optionLabel = "text"
                        className = "addUserDropdown"
                        value = { typeCategory }
                        onChange = { e => setTypeCategory(e.value) }
                        required = { true }
                    />
                    <label>Additional Category</label>
                    <Dropdown
                        options = {categorys.filter(item => item.id !== 0 && item.text !== typeCategory?.text)}
                        optionLabel = "text"
                        className = "addUserDropdown"
                        value = { additionalCategory }
                        onChange = {e => setAdditionalCategory(e.value)}
                    />
                    <label>Custom Hashtag (Optional)</label>
                    <input
                        type = "text"
                        className = "addUserInput"
                        value = { hashtag }
                        onChange = {e => setHashtag(e.target.value)}
                    />
                    <label>Custom Caption (Optional)</label>
                    <textarea
                        className = "addUserInput addUserTextArea"
                        value = { caption }
                        onChange = {e => setCaption(e.target.value)}
                    >
                    </textarea>
                </div>
                {/*<div className="addUserFormCheckinBox">*/}
                {/*    <span className="addUserCustomClientCheckSpan">*/}
                {/*        <label className="checkboxLabel">*/}
                {/*            <input*/}
                {/*                type='checkbox'*/}
                {/*                checked={checkCustomer}*/}
                {/*                onChange={e => setCheckCustomer(e.target.checked)}*/}
                {/*            />*/}
                {/*            <span></span>*/}
                {/*        </label>*/}
                {/*        Custom Client*/}
                {/*    </span>*/}
                {/*    <div className="addUserCustomDataBox" style={{visibility: checkCustomer ? 'visible' : 'hidden'}}>*/}
                {/*        <label style={{marginTop: "40px"}}>*/}
                {/*            Client Country*/}
                {/*        </label>*/}
                {/*        <div className="addUserSocialMediaCheckinBox" style={{margin: 0}}>*/}
                {/*            <span className="addUserCustomClientCheckSpan">*/}
                {/*                <label className="checkboxLabel">*/}
                {/*                    <input*/}
                {/*                        type='checkbox'*/}
                {/*                        checked={checkClientUSA}*/}
                {/*                        onChange={e => {*/}
                {/*                            setCheckClientUSA(e.target.checked);*/}
                {/*                            setCheckClientCanada(!e.target.checked);*/}
                {/*                        }}*/}
                {/*                    />*/}
                {/*                    <span></span>*/}
                {/*                </label>*/}
                {/*                USA*/}
                {/*            </span>*/}
                {/*            <span className="addUserCustomClientCheckSpan">*/}
                {/*                <label className="checkboxLabel">*/}
                {/*                      <input*/}
                {/*                          type='checkbox'*/}
                {/*                          checked={checkClientCanada}*/}
                {/*                          onChange={e => {*/}
                {/*                              setCheckClientCanada(e.target.checked)*/}
                {/*                              setCheckClientUSA(!e.target.checked)*/}
                {/*                          }}*/}
                {/*                      />*/}
                {/*                      <span></span>*/}
                {/*                </label>*/}
                {/*                CANADA*/}
                {/*            </span>*/}
                {/*        </div>*/}
                {/*        <label>*/}
                {/*            Choose Posting Days*/}
                {/*        </label>*/}
                {/*        <div className="addUserWeekDaysBox">*/}
                {/*            {*/}
                {/*                weekDays.map(day =>*/}
                {/*                    <span*/}
                {/*                        key={day.text}*/}
                {/*                        className="addUserWeekDay"*/}
                {/*                        onClick={addDay.bind(this, day)}*/}
                {/*                        style={{*/}
                {/*                            backgroundColor: day.active ? "#3F68B1" : "#FFFFFF",*/}
                {/*                            color: day.active ? "#FFFFFF" : "#3F68B1",*/}
                {/*                            border: "1px solid #3F68B1"*/}
                {/*                        }}*/}
                {/*                    >*/}
                {/*                        {day.text}*/}
                {/*                    </span>*/}
                {/*                )*/}
                {/*            }*/}
                {/*        </div>*/}
                {/*        {*/}
                {/*            concretDay ?*/}
                {/*                <>*/}
                {/*                    <label>*/}
                {/*                        Choose Posting Time*/}
                {/*                    </label>*/}
                {/*                    <TimePicker*/}
                {/*                        label="Choose Time"*/}
                {/*                        className="addUserTimePickerInput"*/}
                {/*                        value={concretDay?.time ? concretDay.time : null}*/}
                {/*                        onChange={value => changeTime(value)}*/}
                {/*                    />*/}
                {/*                    <label>*/}
                {/*                        Social Media*/}
                {/*                    </label>*/}
                {/*                    <div className="addUserSocialMediaCheckinBox">*/}
                {/*                    <span className="addUserCustomClientCheckSpan"*/}
                {/*                          style={{color: errorSocialMedia ? "red" : " rgba(0,0,0,0.5)"}}>*/}
                {/*                        <label className="checkboxLabel">*/}
                {/*                              <input*/}
                {/*                                  type='checkbox'*/}
                {/*                                  checked={concretDay?.postToFacebook}*/}
                {/*                                  onChange={e => changeFacebook(e.target.checked)}*/}
                {/*                              />*/}
                {/*                              <span></span>*/}
                {/*                        </label>*/}
                {/*                        Facebook*/}
                {/*                    </span>*/}
                {/*                        <span*/}
                {/*                            className="addUserCustomClientCheckSpan"*/}
                {/*                            style={{color: errorSocialMedia ? "red" : " rgba(0,0,0,0.5)"}}*/}
                {/*                        >*/}
                {/*                            <label className="checkboxLabel">*/}
                {/*                                  <input*/}
                {/*                                      type='checkbox'*/}
                {/*                                      checked={concretDay?.postToInstagram}*/}
                {/*                                      onChange={e => changeInstagram(e.target.checked)}*/}
                {/*                                  />*/}
                {/*                                  <span></span>*/}
                {/*                            </label>*/}
                {/*                            Instagram*/}
                {/*                        </span>*/}
                {/*                    </div>*/}
                {/*                </>*/}
                {/*                : null*/}
                {/*        }*/}
                {/*        <span className="addUserCustomClientCheckSpan"*/}
                {/*              style={{marginTop: !concretDay ? "30px" : "0px"}}>*/}
                {/*            <label className="checkboxLabel">*/}
                {/*                  <input*/}
                {/*                      type='checkbox'*/}
                {/*                      checked={holidaysPosts}*/}
                {/*                      onChange={e => setHolidaysPosts(e.target.checked)}*/}
                {/*                  />*/}
                {/*                  <span></span>*/}
                {/*            </label>*/}
                {/*            Holiday Posts*/}
                {/*        </span>*/}
                {/*        <div className="addUserHolidaysBox">*/}
                {/*            {*/}
                {/*                holidays.map(hol => <span className="addUserConcretHolidayCheckBox" key={hol.id}>*/}
                {/*                    <label className="checkboxLabel">*/}
                {/*                        <input*/}
                {/*                            type='checkbox'*/}
                {/*                            checked={hol.active}*/}
                {/*                            onChange={checkedThisHoliday.bind(this, hol)}*/}
                {/*                        />*/}
                {/*                        <span></span>*/}
                {/*                        {hol.name}*/}
                {/*                    </label>*/}
                {/*                </span>*/}
                {/*                )*/}
                {/*            }*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="addUserSubmitBox">
                    <input
                        type = "submit"
                        value = "SUBMIT"
                        className = "addUserSubmitBtn"
                        style = {{
                            backgroundColor: typeProfile || typeCategory || facebookId ? "#3F68B1" : "white",
                            color: typeProfile || typeCategory || facebookId ? "#FAFAFA" : "#929292"
                        }}
                    />
                </div>
            </form>
        </div>
    )
}

export default AddUser